﻿import document from 'document';
import { eventBus } from '../../foundation/eventBus';
import { events as formEvents } from '../../feature/form/enable-form';
import { ajaxRequest } from '../../utilities/ajax';

export const accountRegistration = () => {

    let isValidRegistration = false;
    const serverErrorHiddenClass = "form-field-group__server-error--hidden";

    const selectors = { 
        serverError: '.form-field-group__server-error',
    }

    const _redirect = (url) => { 
        window.location = url;
    }

    const _handleTvSquared = component => {
        var _tvq = window._tvq = window._tvq || [];
        const siteId = component.getAttribute("data-tvsquared-siteid");
        const actionTag = component.getAttribute("data-tvsquared-actiontag");

        (function(){
            var actionname = actionTag;
            var action = {
                'rev': '',
                'prod': '',
                'id': actionname,
                'promo': ''
            };

            const tvSquaredDomain = component.getAttribute("data-tvsquared-domain");
            var u = (("https:" == document.location.protocol)
            ? "https://" + tvSquaredDomain
            : "http://" + tvSquaredDomain);
            _tvq.push(['setSiteId', siteId]);
            _tvq.push(['setTrackerUrl', u + 'tv2track.php']);
            _tvq.push([function () {
                this.setCustomVariable(5, actionname, JSON.stringify(action), 'page')
            }]);
            _tvq.push(['trackPageView']);
            var d = document,
                g = d.createElement('script'),
                s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.defer = true;
            g.async = true;
            g.src = u + 'tv2track.js';
            s.parentNode.insertBefore(g, s);
        })();
    }

    const _registerAccount = async (component) => {
        const element = document.querySelector(selectors.serverError);
        const url = component.getAttribute("action");
        const method = component.getAttribute("method");
        const data = new FormData(component);

        data.append("submit", "Submit");

        try {            
            await  ajaxRequest.fetch(url, data, method,
                (response) => {
                    if (response.redirected) {

                        const isTvSquaredEnabled = component.getAttribute("data-tvsquared-enabled");
                        if (isTvSquaredEnabled === "True") {                    
                            _handleTvSquared(component);
                        }
                        
                        _redirect(response.url + '?registration=true');  
                    } else {
                        element.classList.remove(serverErrorHiddenClass);
                    }                 
                });
        }
        catch (err) {
            console.log("Something went wrong!", err);
        }
    }

    const _bindEvents = component => {

        component.addEventListener('submit', async (e) => {
            e.preventDefault();
            
            if (isValidRegistration){
                _registerAccount(component);
            }            
        });
    };

    const init = component => {

        eventBus.subscribe(formEvents.formSubmitted, (data) => {
            isValidRegistration = data.isValidForm;
        });
                
        _bindEvents(component);
    };

    return {
        init,
        selector: '.register-form form'
    };
};